<template>
<v-container fluid>
    <v-card>
        <v-card-title>
            <h2> Approve Rates </h2>
            <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <v-data-table
              :headers="headers"
              :items="rates"
              :items-per-page="5"
              class="elevation-1"
            >
            <template v-slot:item.actions="{ item }">
                <v-btn small color="primary" @click="showApproveDialog(item)"> Approve </v-btn>
                <v-btn small @click="showRejectDialog(item)"> Reject </v-btn>
            </template>
            </v-data-table>
        </v-card-text>
    </v-card>
    <v-dialog persisent v-model="approveDialog" width="50rem">
      <v-card>
          <v-card-title>Approve Rate</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <p> Are you sure you want to approve rate? </p>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="primary" @click="approveDialog = false"> Cancel </v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="approveRate" color="primary" :loading="loading"> Approve </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persisent v-model="rejectDialog" width="50rem">
      <v-card>
          <v-card-title>Reject Rate</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <p> Are you sure you want to reject the request? </p>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="primary" @click="rejectDialog = false"> Cancel </v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="rejectRate" color="primary" :loading="loading"> Reject </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</v-container>
</template>
<script>
import http from '../../../http'

export default {
  name: 'ApproveCherryRates',
  data: function () {
    return {
      rates: [],
      approveDialog: false,
      rejectDialog: false,
      cherryRateTemp: { rate: 0 },
      loading: false,
      headers: [
        { text: 'FCS', value: 'organisation.organisationName' },
        { text: 'Rate', value: 'rate' },
        { text: 'Created By', value: 'createdBy' },
        { text: 'Created At', value: 'dateCreated' },
        { text: 'Actions', value: 'actions', sortable: false }
      ]
    }
  },
  mounted () {
    this.getTempRates()
  },
  methods: {
    showApproveDialog (item) {
      this.approveDialog = true
      this.cherryRateTemp = item
    },
    showRejectDialog (item) {
      this.rejectDialog = true
      this.cherryRateTemp = item
    },
    approveRate () {
      this.loading = true
      http.post('/cherry/rate/approve', this.cherryRateTemp).then(response => {
        this.loading = false
        this.approveDialog = false
        if (response.data.error) {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'warning', message: response.data.message }, { root: true })
        } else {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'primary', message: response.data.message }, { root: true })
        }
        this.getTempRates()
      }).catch(error => {
        this.loading = false
        this.approveDialog = false
        this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response ? error.response.data.message : 'Error ocurred' }, { root: true })
      })
    },
    rejectRate () {
      this.loading = true
      http.post('/cherry/rate/reject', this.cherryRateTemp).then(response => {
        this.loading = false
        this.rejectDialog = false
        if (response.data.error) {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'warning', message: response.data.message }, { root: true })
        } else {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'primary', message: response.data.message }, { root: true })
        }
        this.getTempRates()
      }).catch(error => {
        this.loading = false
        this.rejectDialog = false
        this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response ? error.response.data.message : 'Error ocurred' }, { root: true })
      })
    },
    getTempRates () {
      http.get('/cherry/rate/unapproved')
        .then(response => {
          this.rates = response.data
        })
        .catch(error => {
          console.log('error', error)
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response ? error.response.data.message : 'Error ocurred' }, { root: true })
        })
    }
  }
}
</script>
<style>
</style>
